import React from "react";
import styled from "styled-components";
import { Link, useLocation } from "react-router-dom";
import { palette } from "@/styles/palette";

// 네비게이션 컨테이너
const NavContainer = styled.nav`
    width: 100%;
    height: 68px;
    background-color: ${palette.white};
    border-top: 1px solid ${palette.gray[200]};
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
    padding: 8px 0;
`;

// 네비게이션 아이템
const NavItem = styled(Link)<{ $active: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-decoration: none;
    gap: 4px;
    width: 56px;
    padding-top: ${(props) => (props.$active ? "0" : "8px")};
    transition: all 0.2s ease;
`;

// 아이콘 컨테이너
const IconContainer = styled.div<{ $active: boolean }>`
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${(props) => (props.$active ? palette.primary : palette.gray[500])};
    margin-bottom: ${(props) => (props.$active ? "4px" : "0")};
`;

// 아이콘 이미지
const IconImage = styled.img`
    width: 24px;
    height: 24px;
    object-fit: contain;
`;

// 텍스트 라벨
const Label = styled.span<{ $active: boolean }>`
    font-size: 12px;
    line-height: 16px;
    font-weight: ${(props) => (props.$active ? "600" : "400")};
    color: ${(props) => (props.$active ? palette.primary : palette.gray[500])};
    height: 16px;
    transition: all 0.2s ease;
`;

const BottomNavigation: React.FC = () => {
    const location = useLocation();
    const pathname = location.pathname;

    // 각 탭의 활성화 상태 확인
    const isHome = pathname === "/home" || pathname === "/";
    const isSoolLog = pathname === "/soollog" || pathname.startsWith("/soollog/");
    const isContent = pathname === "/content" || pathname.startsWith("/content/");
    const isMyPage = pathname === "/mypage" || pathname.startsWith("/mypage/");

    return (
        <NavContainer>
            <NavItem to="/home" $active={isHome}>
                <IconContainer $active={isHome}>
                    <IconImage src={isHome ? "/icon/home-active.png" : "/icon/home.png"} alt="홈" />
                </IconContainer>
                <Label $active={isHome}>홈</Label>
            </NavItem>
            <NavItem to="/soollog" $active={isSoolLog}>
                <IconContainer $active={isSoolLog}>
                    <IconImage src={isSoolLog ? "/icon/soollog-active.png" : "/icon/soollog.png"} alt="술로그" />
                </IconContainer>
                <Label $active={isSoolLog}>술로그</Label>
            </NavItem>
            <NavItem to="/content" $active={isContent}>
                <IconContainer $active={isContent}>
                    <IconImage src={isContent ? "/icon/content-active.png" : "/icon/content.png"} alt="콘텐츠" />
                </IconContainer>
                <Label $active={isContent}>콘텐츠</Label>
            </NavItem>
            <NavItem to="/mypage" $active={isMyPage}>
                <IconContainer $active={isMyPage}>
                    <IconImage src={isMyPage ? "/icon/user-active.png" : "/icon/user.png"} alt="마이페이지" />
                </IconContainer>
                <Label $active={isMyPage}>마이페이지</Label>
            </NavItem>
        </NavContainer>
    );
};

export default BottomNavigation;
